import React from "react";
import {
  Input,
  Space,
  Button,
  Col,
  Row,
  message,
  Modal,
  Image,
  Drawer,
  Tooltip,
} from "antd";
import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { CloseOutlined } from "@ant-design/icons";
import VehicleAllocateStore from "../store/VehicleAllocateStore";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import CompanyStore from "../store/CompanyStore";
import AllocateVehicleAdd from "./AllocateVehicleAdd";
import dayjs from "dayjs";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";

class VehicleAllocateList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.allocateStore = new VehicleAllocateStore();
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      offset: 50,
      limit: 0,
      pageSize: 50,
      currentPage: 1,
      status: "",
      companyVal_Lab: "",
      searchField: "",
      // companyLoading: false,
      loadList: 0,
      openVehicleAllocateForm: false,
      allocateVehicleId: "",
      listDataUpdate: false,

      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        // title: "Driver Name",
        title: context.translate("_DRIVER_NAME_"),
        dataIndex: "drivername",
        width: 12,
        render: (val, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate("VehicleAllocateList") &&
                  this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
      },
      {
        // title: "Vehicle No",
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        width: 12,
      },
      {
        // title: "  Allocate Date",
        title: context.translate("_ALLOCATE_DATE_"),
        dataIndex: "allocateDate",
        width: 10,
        render: (value) => {
          if (value) {
            const formattedDate =dayjs.utc(value).format("YYYY-MM-DD"); // dayjs(value).format("YYYY-MM-DD");
            return <>{formattedDate}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        // title: " Days Used",
        title: context.translate("_DAYS_USED_"),
        dataIndex: "dayUsed",
        width: 10,
      },
      {
        // title: "Total Amount",
        title: context.translate("_AMOUNT_"),
        dataIndex: "totalAmount",
        width: 10,
      },
      {
        // title: "Project Name",
        title: context.translate("_PROJECT_NAME_"),
        dataIndex: "pcName",
        width: 10,
      },
      {
        // title: "Allocate To",
        title: context.translate("_ALLOCATE_TO_"),
        dataIndex: "allocateTo",
        width: 10,
        render: (val) => {
          if (val == 1) {
            return "Driver";
          } else {
            return "Project";
          }
        },
      },
      {
        // title: "Status",
        title: context.translate("_FLEET_USER_USERLIST_STATUS_"),
        dataIndex: "returnStatus",
        width: 10,
        render: (val) => {
          if (val == 0) return "Vehicle Allocated";
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        width: 5,
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Space>
                {/* <Link
                  onClick={(e) => {
                    e.preventDefault();
                    this.onEdit(record);
                  }}
                >
                  <Tooltip 
                  // title="Edit Vehicle Details" 
                  title={context.translate("_EDIT_VEHICLE_DETAILS_")}
                  placement="bottom" color={config.tooltipColorEdit}>
                  <EditFilled />
                  </Tooltip>
                </Link> */}
                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link>
                    <Tooltip
                      //  title="Delete Vehicle"
                      title={context.translate("_DELETE_VEHICLE_DETAILS_")}
                      placement="bottom"
                      color={config.tooltipColorDelete}
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm> */}
                <Tooltip title={context.translate("_EDIT_VEHICLE_DETAILS_")} placement="bottom">
                  {this.props.canUpdate("VehicleAllocateList") && (
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  )}
                </Tooltip>
                <Tooltip
                  title={context.translate("_DELETE_VEHICLE_DETAILS_")}
                  placement="bottom"
                >
                  {this.props.canDelete("VehicleAllocateList") && (
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  )}
                </Tooltip>
              </Space>
            </>
          );
        },
      },
    ];

    this.ExportMenuProps = {
      items: [
        {
          // label: "Excel",
          label: context.translate("_EXPORT_AS_EXCEL_"),
          key: "excel",
          icon: (
            <Image
              style={{ height: "16px", width: "16px" }}
              src={Excel}
            ></Image>
          ),
        },
      ],
      onClick: (val) => {
        if (this.allocateStore?.returnAsset?.length == 0) return;
        const result = [];
        this.columns.map((obj) => result.push(obj.dataIndex));

        var getData = {
          cid: this.state.companyId,
          searchField: this.state.searchField,
          colList: result,
        };

        if (val.key == "excel") {
          this.allocateStore.exportExcel(getData);
        }
      },
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setVehicleAllocateStates =
        this.context.viewStateStore.vehicleAllocateObject;

      await this.setState({ companyId: setVehicleAllocateStates.companyId });
      if (setVehicleAllocateStates !== "") {
        await this.allocateStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          // searchField: setVehicleAllocateStates.searchText,
          companyId: setVehicleAllocateStates.companyId,
          isadmin: this.props.getUserData().isadmin,
          userId: this.props.getUserData().userId,
        });
        const singleData = await this.companyStore.getCompanyDataById(
          setVehicleAllocateStates.companyId
        );

        await this.setState({ loadData: 1 });

        await this.setState({ companyVal_Lab: singleData });
      }
      this.setState({ listDataUpdate: false });
    }
  }

  async componentDidMount() {
    // await this.allocateStore.loadData({ offset: 0, limit: 50 });
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      //  console.log(this.state.companyId)
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }

    this.setState({ pageSize: 50 });
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);

    await this.setState({ companyVal_Lab: singleData });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.allocateStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
    });
    await this.setState({ loadList: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  onEdit = async (record) => {
    const Id = record.Id;

    if (Id) {
      this.context.viewStateStore.setVehicleAllocateStates({
        companyId: record.companyId,
      });
      await this.setState({ allocateVehicleId: Id });
      await this.setState({ openVehicleAllocateForm: true });
      // this.props.navigate("/allocatevehicleadd/" + Id);
    }
  };

  onSearchClick = async () => {
    if (!this.state.companyId) {
      this.setState({ companyFieldHighlight: true });
    } else {
      this.setState({ companyFieldHighlight: false });
    }
    if (this.state.companyId) {
      this.setState({ companyFieldHighlight: false, loading: true });
      if (this.state.companyId && this.state.searchField.length > 0) {
        await this.allocateStore.loadData({
          offset: 0,
          limit: 10,
          searchField: this.state.searchField,
          companyId: this.state.companyId,
        });
      }

      await this.setState({ loadList: 1 });
    }
  };

  searchInput = async (e) => {
    const value = e.target.value;
    // await this.setState({searchField:value})
    if (value.length >= 3 || value.length === 0) {
      await this.allocateStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 1 });
    }
  };
  async onDelete(record) {
    const response = await this.allocateStore.deleteRecord({
      Id: record.Id,
    });
    //  console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  responseMsg = async (resp) => {
    if (resp.data.success == "S") {
      message.success(resp.data.message);
      // this.props.navigate("/vehicleallocatelist");
      await this.setState({ openVehicleAllocateForm: false });
      await this.setState({ listDataUpdate: true });
    } else if (resp.data.success == "F0") {
      resp.data.errors.map((value) => {
        message.error(value["username"]);
      });
    }
  };

  closeModal = () => {
    this.setState({ openVehicleAllocateForm: false, userId: "" });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    await this.allocateStore.loadData({
      companyId: this.state.companyId,
      offset: 0,
      limit: 50,
      searchField: "",
    });
    this.setState({ loading: false, searchField: "", currentPage: 1 });
  };

  render() {
    const companyInputBox = this.state.companyFieldHighlight
      ? { border: "2px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={(value) => this.handleChange(value)}
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                  style={companyInputBox}
                />

                <Input
                  placeholder={this.context.translate(
                    "_SEARCH_BY_VEHICLE_NO_DRIVER_NAME_"
                  )}
                  style={{ width: 400, borderRadius: "25px" }}
                  value={this.state.searchField ? this.state.searchField : ""}
                  onChange={(e) => {
                    this.setState({ searchField: e.target.value });
                    this.searchInput(e);
                  }}
                />
                {/* <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  onClick={this.onSearchClick}
                /> */}
              </Space>
            </Col>

            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Space>
                <Tooltip title={this.context.translate("_REFRESH_")} placement="bottom">
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>

                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.allocateStore?.allocateVehicles?.length > 0
                      ? false
                      : true
                  }
                  onClick={(val) => {
                    let result = [];
                    if (true) {
                      const result = [];
                      this.columns.map((obj) => result.push(obj.dataIndex));

                      var getData = {
                        cid: this.state.companyId,
                        searchField: this.state.searchField,
                        colList: result,
                      };
                      if (val) {
                        this.allocateStore.exportExcel(getData);
                      }
                    }
                  }}
                >
                  <Tooltip title={this.context.translate("_DOWNLOAD_EXCEL_")} placement="bottom">
                    <Image
                      style={{
                        height: 18,
                        width: "auto",
                      }}
                      src={downloadIcon}
                    />
                  </Tooltip>
                </Button>

                {this.props.canCreate("VehicleAllocateList") && (
                  <Button
                    className="addButtonClass"
                    onClick={() =>
                      this.setState({
                        openVehicleAllocateForm: true,
                        allocateVehicleId: "",
                      })
                    }
                  >
                    <Image
                      style={{ marginInlineEnd: "5px", width: 13 }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    ></Image>
                    {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.allocateStore?.total}
            columns={this.columns}
            dataSource={this.allocateStore?.allocateVehicles}
            loading={this.allocateStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openVehicleAllocateForm && (
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openVehicleAllocateForm}
            placement={this.context.locale.language === "english" ? "right" : "left"}
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_ALLOCATE_VEHICLE_")}
                <p className="formDescription">
                  {this.context.translate("_ALLOCATE_VEHICLE_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openVehicleAllocateForm: false })}
            onCancel={() =>
              this.setState({ openVehicleAllocateForm: false, userId: "" })
            }
          >
            <div style={{ height: "100%" }}>
              {/* <UserAdd
                  userId={this.state.userId}
                  response={this.responseMsg} */}
              {/* /> */}
              <div style={{ height: "100%" }}>
                <AllocateVehicleAdd
                  allocateVehicleId={this.state.allocateVehicleId}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              </div>
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
VehicleAllocateList.contextType = StoreContext;
export default observer(withRouter(VehicleAllocateList));
